// ABOUTME: Skeleton loading placeholder shown in the detail body while entity data is loading.
// ABOUTME: Renders a narrow label row plus full-width input-like rows to mimic form content.
import React from 'react'

interface EntityContentSkeletonProps {
  rows?: number
}

export const EntityContentSkeleton: React.FC<EntityContentSkeletonProps> = ({rows = 3}) => (
  <div className="flex flex-col gap-6 p-6 animate-pulse">
    {Array.from({length: rows}, (_, i) => (
      <div
        key={i}
        className={`${i === 0 ? 'h-6 w-48' : 'h-10 w-full'} bg-border rounded`}
      />
    ))}
  </div>
)
